import { setQueryParams } from '../helpers/location';

/**
 * Calculate query parameters for apply
 * Calculate parameters that should change browser history state
 */
function calcQueryParams({ tab, profiles, stories }) {
    const params = { tab };
    switch (tab) {
    case 'profiles': {
        const { query, profilesType } = profiles.search;
        const { page } = profiles.profiles;
        return Object.assign(params, {
            page,
            query,
            profiles_type: profilesType,
        });
    }
    case 'stories': {
        const { page, query, from, to } = stories;
        return Object.assign(params, { page, query, from, to });
    }
    default:
        return params;
    }
}

/**
 * History middleware
 * When attached to store, listens it state and change browser history state accordingly
 */
export default function historyMiddleware(store) {
    let replace = true;

    return next => (action) => {
        const result = next(action);

        setQueryParams(calcQueryParams(store.getState()), replace);
        replace = false;

        return result;
    };
}



// WEBPACK FOOTER //
// ./src/js/middleware/historyMiddleware.js